// extracted by mini-css-extract-plugin
export default {"priceContainer":"aia-z","discountedPrice":"bia-z","originalPrice":"cia-z","productPrice":"dia-z"};